import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { resetPassword, resendResetOtp } from '../../services/authService';
import PasswordInput from './PasswordInput';
import './styles/Login.css';

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();

  const [email, setEmail] = useState(location.state?.email || '');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [resendIn, setResendIn] = useState(0);

  useEffect(() => {
    if (resendIn <= 0) return;
    const t = setInterval(() => setResendIn((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [resendIn]);

  const onResend = async () => {
    setMsg('');
    setError('');
    try {
      await resendResetOtp(email);
      setMsg('OTP resent successfully.');
      setResendIn(30);
    } catch (e) {
      setError(e?.response?.data?.message || 'Failed to resend OTP');
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    setSubmitting(true);
    try {
      const data = await resetPassword({ email, otp, newPassword });
      setMsg(data?.message || 'Password reset successful');
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err?.response?.data?.message || 'Password reset failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-eyebrow">
            <span className="auth-eyebrow-dot" aria-hidden="true" />
            Password recovery
          </div>
          <h2 className="auth-title">Reset password</h2>
          <p className="auth-subtitle">Enter the code we sent to your email and choose a new password.</p>
        </div>

        {msg && (
          <div className="auth-alert" role="alert"
            style={{ borderColor: 'rgba(34,197,94,0.25)', background: 'rgba(34,197,94,0.07)', color: 'rgba(187,247,208,0.95)' }}>
            {msg}
          </div>
        )}
        {error && <div className="auth-alert" role="alert">{error}</div>}

        <form onSubmit={onSubmit} className="auth-form" noValidate>
          <div className="auth-field">
            <label className="auth-label">Email address</label>
            <input
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="auth-field">
            <label className="auth-label">One-time code (OTP)</label>
            <input
              className="auth-input"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter the 6-digit code"
              required
            />
          </div>

          <PasswordInput
            label="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Create a new password"
            required
          />

          <button className="auth-button" disabled={submitting} type="submit">
            {submitting ? 'Resetting…' : 'Reset Password →'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login" className="auth-link">← Back to sign in</Link>
          <button
            className="t-btn"
            type="button"
            disabled={submitting || resendIn > 0}
            onClick={onResend}
          >
            {resendIn > 0 ? `Resend in ${resendIn}s` : 'Resend code'}
          </button>
        </div>
      </div>
    </div>
  );
}
